import React, { Component } from 'react';
import {Group, Image, Transformer, Ellipse} from 'react-konva';
import DeleteButton from '../Shapes/deleteButton';
// import shapeClasses from './shapeClasses.css';



class Gift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: [],
      resizable: true,
      posx: this.props.x,
      posy: this.props.y,
    }
  }
  mouseDown = false;

  onMouseOver = (e) => {
    document.body.style.cursor = 'grab';
  }

  onMouseOut = (e) => {
    document.body.style.cursor = 'default';
  }

  onMouseDown = (e) => {
    document.body.style.cursor = 'grabbing';
    this.mouseDown = true;
  }

  onMouseUp = (e) => {
    document.body.style.cursor = 'grab';
    this.mouseDown = false;
    this.props.setGiftInitialPosition(e.target.x(), e.target.y(), this.props.i, this);
  }

  handleClick = (e) => {
    // if (~e.target.name().indexOf('gift')) {
    //   e.target.parent.findOne('Transformer').rotateEnabled(true);
    //   e.target.parent.findOne('Transformer').borderEnabled(true);
    //   e.target.parent.findOne('Transformer').resizeEnabled(true);
    //   e.target.parent.findOne('Transformer').getLayer().batchDraw();
    //   e.target.parent.findOne('Transformer').forceUpdate();
    //
    // }
  }

  setDeleteButtonPosition = (target) => {
    const visibility = target.parent.findOne('.deleteButton').getAttr('visible');
    this.setState({
      posx: target.attrs.x,
      posy: target.attrs.y,
    })
    target.parent.findOne('.deleteButton').setAttr('visible', visibility);
  }

  componentDidMount() {
    // const stage = this.transform.getStage();
    // const giftImg = stage.find(".gift");
    // for (let i = 0; i < giftImg.length; i++) {
    //   giftImg[i].parent.findOne('Transformer').attachTo(giftImg[i]);
    //   giftImg[i].parent.findOne('Transformer').getLayer().batchDraw();
    //   let shapes = [].slice.call(giftImg[i].parent.findOne('Transformer').find('Shape'));
    //   shapes.forEach(item => {
    //     if (item.className === 'Rect') {
    //       if (item.name() !== 'rotater') {
    //       } else {
    //         item.borderStroke ='white';
    //       }
    //     } else {
    //       item.borderStroke = 'white';
    //       item.borderStrokeWidth ='2';
    //       item.borderDash = [5,2];
    //     }
    //   });
    // }
  }

  render() {
    return (
      <Group
        key={`GroupGift-${this.props.i}`}
      >
        <Image
          // onMouseOver={e => this.onMouseOver(e)}
          // onMouseOut={e => this.onMouseOut(e)}
          // onMouseDown={e => this.onMouseDown(e)}
          // onMouseUp={e => this.onMouseUp(e)}
          nameRef={`gift${this.props.i}`}
          name="gift"
          image={this.props.image}
          x={this.state.posx}
          y={this.state.posy}
          width={this.props.side}
          height={this.props.side}
          // onClick={e => this.handleClick(e)}
          // onTap={e => this.handleClick(e)}
          // draggable
          // onDragMove={(e) => this.setDeleteButtonPosition(e.target)}
          // onDragEnd={(e) => this.props.setGiftInitialPosition(e.target.x(), e.target.y(), this.props.i, this)}
          // onTransform={(e) => this.setDeleteButtonPosition(e.currentTarget)}
          // onTransformEnd={(e) => this.props.setGiftInitialPosition(e.target.x(), e.target.y(), this.props.i, this)}
        />
        <Transformer
          ref={node => {
            this.transform = node;
          }}
          // anchorSize={window.innerWidth > 1120 ? 12 : 25}
          name={`gift-transform-${this.props.i}`}
          // rotateAnchorOffset={window.innerWidth > 1120 ? 25 : 50}
          // borderStroke = {'white'}
          // borderStrokeWidth = {2}
          // borderDash = {[5,2]}
        />
        <DeleteButton
          posx={this.state.posx}
          posy={this.state.posy}
          deleteElement={this.props.deleteElement}
          parent = {this}
          visible={false}
          name='deleteButton'
          className = "deleteButton"
        />
      </Group>
    )
  }
}

export default Gift;



// WEBPACK FOOTER //
// ./src/components/Gifts/Gift.js